/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */

// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import get from 'transmute/get';
import PropTypes from 'prop-types';
import UILink from 'UIComponents/link/UILink';
import PortalIdParser from 'PortalIdParser';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getEmailEditConfigurationUrl } from 'conversations-external-deep-links/urls';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getEmail } from 'conversations-internal-schema/connected-email-account/operators/connectedEmailAccountGetters';
import { getId, getConnectedAccountContext, getMarketingEmailContext, getSubject, getCampaignId, getCampaignGroupId } from 'conversations-message-history/context-update/operators/contextUpdateGetters';
import { useConnectedAccounts } from 'conversations-thread-data/connected-accounts/public';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  inboxId: PropTypes.number.isRequired,
  message: RecordPropType('ContextUpdateMessage').isRequired
};
const ConnectedAccountContextUpdate = ({
  inboxId,
  message
}) => {
  const {
    asyncConnectedAccounts
  } = useConnectedAccounts({
    inboxId
  });
  const connectedAccountContext = getConnectedAccountContext(message);
  const marketingEmailContext = getMarketingEmailContext(message);
  const emailId = getId(connectedAccountContext);
  const connectedAccounts = getData(asyncConnectedAccounts);
  if (connectedAccounts) {
    const connectedAccount = get(`${emailId}`, connectedAccounts);
    const email = getEmail(connectedAccount);
    if (connectedAccount) {
      const connectedAccountLink = /*#__PURE__*/_jsx(UILink, {
        href: getEmailEditConfigurationUrl({
          inboxId,
          emailId
        }),
        external: true,
        use: "blue",
        children: email
      });
      if (marketingEmailContext) {
        const marketingSubject = getSubject(marketingEmailContext);
        const campaignId = getCampaignId(marketingEmailContext);
        const campaignGroupId = getCampaignGroupId(marketingEmailContext);
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "conversations-thread-view.threadHistory.context-update-message.marketingEmail",
          options: {
            marketingEmail: /*#__PURE__*/_jsx(UILink, {
              href: `/email/${PortalIdParser.get()}/campaign/${campaignGroupId || campaignId}`,
              external: true,
              use: "blue",
              children: marketingSubject
            }),
            connectedAccount: connectedAccountLink
          }
        });
      }
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "conversations-thread-view.threadHistory.context-update-message.connectedAccount",
        options: {
          connectedAccount: connectedAccountLink
        }
      });
    }
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: 'conversations-thread-view.threadHistory.context-update-message.unknownSourceMessage'
  }, 'chatflow-source-message');
};
ConnectedAccountContextUpdate.propTypes = propTypes;
export default ConnectedAccountContextUpdate;